"use strict";var $export=require("./_export");$export($export.S,"Math",{signbit:function(r){return(r=+r)!=r?r:0==r?1/r==1/0:r>0}});